import { Modal, Button, Form, Input } from 'antd';
import { useFetcher } from '@remix-run/react';
import { useEffect } from 'react';
import { useDialog } from '~/hooks';
import { atom } from 'jotai';

const activateSubscriptionModal = atom(false);

export function useActivateSubscriptionDialog() {
    return useDialog(activateSubscriptionModal);
}

export default function ActivateSubscriptionModal() {
    const { isOpened, closeDialog } = useActivateSubscriptionDialog();
    const fetcher = useFetcher();

    const onFinish = (values: any) => {
        fetcher.submit(values, {
            method: 'POST',
            action: '/subscription',
        });
    };

    const data = fetcher.data;
    const state = fetcher.state;

    useEffect(() => {
        function sendConversionToGoogle() {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);
            }

            gtag('event', 'conversion', {
                send_to: 'AW-16850919995/oCKtCPnxmaQaELvEkuM-',
                value: 19.99,
                currency: 'USD',
                transaction_id: '',
            });
        }

        if (state === 'idle' && data?.isError === false) {
            sendConversionToGoogle();
            window.location.reload();
        }
    }, [state, data]);

    return (
        <Modal
            centered
            open={isOpened}
            destroyOnClose={true}
            onOk={() => {}}
            onCancel={closeDialog}
            footer={null}>
            <div className='flex w-full flex-col items-center justify-center'>
                <h2 className='py-4 text-center text-2xl'>
                    🔑 Type your activation code below
                </h2>
                <Form
                    name='basic'
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    style={{ maxWidth: 600 }}
                    onFinish={onFinish}
                    autoComplete='off'>
                    <Form.Item
                        label='Code'
                        name='code'
                        rules={[
                            {
                                required: true,
                                message: 'Please input your license key',
                            },
                            { max: 20, message: 'Invalid license key' },
                            { min: 10, message: 'Invalid license key' },
                        ]}>
                        <Input />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button
                            type='primary'
                            htmlType='submit'
                            size='large'
                            loading={fetcher.state !== 'idle'}>
                            Activate
                        </Button>
                    </Form.Item>
                    {fetcher.state === 'idle' && fetcher.data?.isError && (
                        <div className='w-full text-center'>
                            <p className='text-red-500'>
                                Failed to activate subscription
                            </p>
                        </div>
                    )}
                </Form>
            </div>
        </Modal>
    );
}
